import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const Work = () => import("../views/Work.vue");
const Feature = () => import("../views/Feature.vue");
const Works = () => import("../views/Works.vue");
const About = () => import("../views/About.vue");
const Shop = () => import("../views/Shop.vue");
const Blog = () => import("../views/Blog.vue");

export default new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
		{
			path: "/",
			name: "home",
			component: Home
		},
		{
			path: "/work/:id",
			name: "work",
			component: Work,
			props: true
		},
		{
			path: "/about",
			name: "about",
			component: About
		},
		{
			path: "/shop",
			name: "shop",
			component: Shop
		},
		{
			path: "/works",
			name: "works",
			component: Works
		},
		{
			path: "/feature/:id",
			name: "feature",
			component: Feature
		},
		{
			path: "/blog/:id",
			name: "blog",
			component: Blog
		},
		{
			path: "*",
			redirect: "/"
		}
	],
	scrollBehavior() {
		return new Promise(resolve => {
			setTimeout(() => {
				resolve({x: 0, y: 0})
			}, 400)
		})
	}
});
